<template>
  <div>
    <v-row
      class="primary create-promotion-header"
      elevation="4">
      <code class="ma-2 white create-promotion-header-title pt-1">
        <h2>{{ pageTitle }}</h2>
      </code>
      <v-spacer />
      <v-btn
        color="warning"
        class="ma-2"
        @click="goToFilterList()">
        ปิด
      </v-btn>
    </v-row>
    <v-row justify="space-around">
      <v-sheet
        width="100%"
        elevation="4"
        class="py-10 px-12 create-promotion">
        <validation-observer
          ref="obs"
          tag="form"
          @submit.prevent="onSubmit()">
          <v-col cols="12">
            <create-form
              v-if="ready"
              :datas="promotionDetail"
              :editable="editable"
              @input="bindValue($event)" />
          </v-col>
          <v-col cols="12">
            <v-row justify="center">
              <v-col
                cols="2"
                class="text-right">
                <h4 class="pt-2">
                  ชื่อโปรโมชั่น
                </h4>
              </v-col>
              <v-col cols="3">
                <v-text-field
                  v-model="promotionName"
                  solo
                  :readonly="!editable"
                  style="height: 60px" />
              </v-col>
              <v-col cols="2">
              </v-col>
            </v-row>
          </v-col>
          <v-col
            v-if="$route.params.action !== 'detail'"
            cols="12"
            class="text-center">
            <v-btn
              type="submit"
              color="primary">
              สร้าง
            </v-btn>
          </v-col>
        </validation-observer>
      </v-sheet>
    </v-row>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import PromotionsProvider from '@/resources/PromotionsProvider'
// import MainProvider from '@/resources/MainProvider'
import SegmentPromotionsProvider from '@/resources/SegmentsPromotionsProvider'
import CreateForm from '../components/CreateForm.vue'

const promotionsService = new PromotionsProvider()
const segmentPromotionsService = new SegmentPromotionsProvider()

export default {
  components: {
    CreateForm
  },
  data () {
    return {
      ready: false,
      promotionName: '',
      form: {
        filterId: '',
        reQuery: false,
        duration: {},
        templates: []
      },
      promotionDetail: {}
    }
  },
  computed: {
    pageTitle () {
      let title = ''
      if (this.$route.params.action === 'create') {
        title = 'สร้างโปรโมชั่น'
      } else {
        title = 'โปรโมชั่น'
      }

      return title
    },
    editable () {
      return this.$route.params.action !== 'detail'
    }
  },
  async created () {
    this.paramsVerify()
    this.promotionDetail = await this.initPromotionDetail()
    this.ready = true
  },
  methods: {
    ...mapActions({
      setSnackBar: 'Style/setSnackbar',
      setModal: 'Style/setModal',
      setLoading: 'Style/setLoading'
    }),
    paramsVerify () {
      const allowParams = ['create', 'edit', 'detail']

      if (!allowParams.some((param) => param === this.$route.params.action)) {
        this.setSnackBar({
          value: true,
          message: 'มีบางอย่างไม่ถูกต้อง',
          type: 'warning'
        })
        this.$router.push({ name: 'FilteredList' })
      }
    },
    bindValue (val) {
      this.form = val
    },
    goToFilterList () {
      this.$router.push({ name: 'FilteredList' })
    },
    async initPromotionDetail () {
      if (this.$route.params.action !== 'create') {
        const { data } = await promotionsService.getPromotionById(this.$route.params.id)
        this.promotionName = data.name
        return data
      }

      return { filterId: this.$route.params.id }
    },
    async onSubmit () {
      const validated = await this.validateForm()
      if (validated === 'success') {
        this.$router.push({ name: 'FilteredList' })
      }
    },
    async validateForm () {
      const alert = {
        message: 'เกิดข้อผิดพลาด',
        type: 'error'
      }
      try {
        this.setLoading({ value: true })
        const validated = await this.$refs.obs.validate()
        if (validated) {
          const res = this.$route.params.action === 'create' ? await this.createPromotion() : await this.updatePromotion()
          if (res) {
            alert.message = this.$route.params.action === 'create' ? 'สร้างโปรโมชั่นสำเร็จ' : 'อัพเดตโปรโมชั่นสำเร็จ'
            alert.type = 'success'
          } else {
            alert.message = this.$route.params.action === 'create' ? 'สร้างโปรโมชั่นไม่สำเร็จ' : 'อัพเดตโปรโมชั่นไม่สำเร็จ'
            alert.type = 'error'
          }
        }
      } catch (error) {
        alert.message = `ผิดพลาด ${error.code}: ${error.message}`
        alert.type = 'error'
      } finally {
        this.setLoading({ value: false })
        this.setSnackBar({
          value: true,
          message: alert.message,
          type: alert.type
        })
      }
      return alert.type
    },
    async updatePromotion () {
      const { data } = await promotionsService.updatePromotion(
        this.$route.params.id,
        {
          name: this.promotionName,
          ...this.form
        }
      )

      return data
    },
    async createPromotion () {
      const { data } = await segmentPromotionsService.createPromotion({
        name: this.promotionName,
        ...this.form
      })

      return data
    }
  }
}
</script>

<style>
.create-promotion .v-input--selection-controls .v-input__slot > .v-label, .v-input--selection-controls .v-radio > .v-label {
  color: black;
}

.create-promotion-header {
  height: 50px;
}

.create-promotion-header-title {
  border-radius: 10px;
  color: black !important;
}

</style>
